function resolveApiUrl() {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL
  }

  if (import.meta.env.VITE_DOCKER === 'true') {
    return `${window.location.protocol}//${window.location.hostname}/api`
  }

  if (import.meta.env.PROD) {
    return 'https://api-xpansvault.xpanstech.com/api'
  }

  return '/api'
}

export default {
  API_URL: resolveApiUrl()
}
